import { Skeleton, Stack, styled } from '@mui/material';
import { ComponentProps } from 'react';

export const SkeletonContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const DescriptionContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
}));

export const TitleSkeletonBase = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(3),
  width: '15%',
  [theme.breakpoints.down('md')]: { width: '100%' },
}));

export const TitleSkeleton = (
  props: ComponentProps<typeof TitleSkeletonBase>
) => <TitleSkeletonBase variant="rectangular" {...props} />;

export const LimitsSkeletonBase = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(3),
  width: '50%',
  [theme.breakpoints.down('md')]: { width: '100%' },
}));

export const LimitsSkeleton = (
  props: ComponentProps<typeof LimitsSkeletonBase>
) => <LimitsSkeletonBase variant="rectangular" {...props} />;

export const ImageSkeletonBase = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(45),
  width: theme.spacing(45),
  [theme.breakpoints.down('md')]: { alignSelf: 'center' },
}));

export const ImageSkeleton = (
  props: ComponentProps<typeof ImageSkeletonBase>
) => <ImageSkeletonBase variant="rectangular" {...props} />;
